import React from 'react';

export const HealthCheck: React.FC = () => {
  return <div>OK</div>;
};
